<template>
  <button type="button"
    class="btn btn-link btn-wide text-muted"
    v-on:click="postMessageToWindow"
    aria-label="Cancel"
    tabindex="1">
    <slot></slot>
  </button>
</template>

<script>
import postMessageToWindow from '@/api/postMessageToWindow';
import SegmentMixin from '@/mixins/SegmentMixin';

/**
 * Cancel Button
 *
 * A common cancel button, useful for forms.
 */
export default {
  name: 'CancelButton',
  mixins: [
    SegmentMixin,
  ],
  props: {
    /**
     * Location of the cancel button
     */
    location: String,
  },
  methods: {
    /**
     * Posts close message to parent window on button click
     */
    postMessageToWindow() {
      const data = {
        close: true,
        reason: 'dismiss',
        location: this.location,
        data: {
          hasShippingData: this.$store.state.hasShippingData,
        },
      };
      // Callback to close the iframe. To be executed by segment after
      // tracking and a short timeout.
      const callback = () => postMessageToWindow(data);
      this.trackCurrentFormEvent(
        this.segment.constants.events.CLOSED,
        null,
        callback,
      );
    },
  },
};
</script>
